import { createReceiveReducer } from 'utils/redux'

export default createReceiveReducer({}, 'playbooks')
